module.exports = __webpack_public_path__ + "6a6cc58556088b94ab417e3475cfe220.png";